module.exports = __webpack_public_path__ + "img/place-rosemere.73531e59.webp";